/**
 * i18n bootstrap.
 *
 * All 5 language files are pre-loaded (it/en/es/no/ru). The active language
 * is chosen by:
 *   1. `REACT_APP_DEFAULT_LOCALE` env var (set per instance in `.env`)
 *   2. localStorage key `gp_locale` (browser session preference)
 *   3. Browser navigator language
 *   4. Fallback: `it`
 *
 * Adding a NEW language:
 *   1. Create `src/i18n/locales/<code>.json` (copy `it.json` and translate values).
 *   2. Import & register below.
 *   3. Set `REACT_APP_DEFAULT_LOCALE=<code>` in `.env` for that deployment.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import en from './locales/en.json';
import es from './locales/es.json';
import no from './locales/no.json';
import ru from './locales/ru.json';

const explicitLocale = process.env.REACT_APP_DEFAULT_LOCALE;

const resources = {
  it: { translation: it },
  en: { translation: en },
  es: { translation: es },
  no: { translation: no },
  ru: { translation: ru },
};

const initOptions = {
  resources,
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupLocalStorage: 'gp_locale',
  },
  returnEmptyString: false,
};

// If REACT_APP_DEFAULT_LOCALE is explicitly set at build time (typical for
// deployed language instances), FORCE that locale and skip the detector.
// Otherwise let the detector pick from localStorage / navigator (useful for
// dev multi-language testing).
if (explicitLocale) {
  initOptions.lng = explicitLocale;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(initOptions);

export default i18n;
